// Client-side matcher for CustomAlert#path_prefixes (see the column comment in
// app/models/custom_alert.rb). Filtering happens here — not on the server — so
// the visible alert set follows vue-router navigation, where the Rails request
// path stays frozen at the initially loaded URL.
//
// An empty prefixes array matches every page. Otherwise the path matches when
// any of the patterns does:
//   - Without `*`: prefix match — `/locations` matches `/locations`,
//     `/locations/123`, etc.
//   - With `*`:   `*` is a single URL segment wildcard (won't cross `/`).
//                 `/locations/*/v2/keywords` matches `/locations/abc/v2/keywords`
//                 and its sub-paths, but not `/locations/abc/v2/keywords-extra`.
const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

const patternMatches = (path, pattern) => {
  if (!pattern.includes('*')) return path.startsWith(pattern)

  // Build regex: escape pattern, then convert `*` → `[^/]+`. Anchor at start
  // and require a segment boundary at the end so `/foo` doesn't match `/foobar`.
  const regexBody = pattern.split('*').map(escapeRegExp).join('[^/]+')
  return new RegExp(`^${regexBody}($|/)`).test(path)
}

export default function matchesPathPrefixes(path, prefixes) {
  if (!prefixes || prefixes.length === 0) return true

  return prefixes.some((pattern) => patternMatches(path, pattern))
}
